function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.875 14.375L9.62507 10.125M11.0417 6.58333C11.0417 9.32175 8.82175 11.5417 6.08333 11.5417C3.34492 11.5417 1.125 9.32175 1.125 6.58333C1.125 3.84492 3.34492 1.625 6.08333 1.625C8.82175 1.625 11.0417 3.84492 11.0417 6.58333Z",
  stroke: "#666666",
  strokeWidth: 1.41667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.b8c9b437d93e69a6ed7e904e2f6597b9.svg";
export { ForwardRef as ReactComponent };